import React from "react";
import { Mail, Globe, Phone } from "lucide-react";

const BusinessCard = () => {
  const handleEmailClick = () => {
    window.location.href = 'mailto:sabrina.adjarsa@responsia.fr';
  };

  const handleWebClick = () => {
    window.open('https://www.responsia.fr', '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+33666027925';
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-5 relative overflow-hidden"
      style={{
        background: '#E8E4FA',
        fontFamily: "'Plus Jakarta Sans', sans-serif"
      }}
    >
      {/* Ambient blobs */}
      <div 
        className="absolute pointer-events-none"
        style={{
          top: '-150px',
          left: '-150px',
          width: '500px',
          height: '500px',
          background: 'radial-gradient(circle, rgba(155,79,232,0.18) 0%, transparent 65%)'
        }}
      />
      <div 
        className="absolute pointer-events-none"
        style={{
          bottom: '-120px',
          right: '-120px',
          width: '450px',
          height: '450px',
          background: 'radial-gradient(circle, rgba(59,139,245,0.14) 0%, transparent 65%)'
        }}
      />

      <div className="relative z-10">
        {/* Card */}
        <div 
          className="relative bg-white rounded-2xl overflow-hidden flex"
          style={{ 
            width: 'min(520px, 92vw)', 
            aspectRatio: '85/54',
            boxShadow: '0 2px 0 rgba(255,255,255,0.9) inset, 0 24px 70px rgba(139,63,217,0.18), 0 6px 20px rgba(0,0,0,0.07)',
            animation: 'rise 0.65s cubic-bezier(.22,1,.36,1) both'
          }}
        >
          {/* Left colored bar */}
          <div 
            className="w-[7px] flex-shrink-0"
            style={{
              background: 'linear-gradient(135deg, #C847A8 0%, #8B3FD9 45%, #3B8BF5 100%)'
            }}
          />
          
          {/* Main content */}
          <div className="flex-1 flex items-center px-5 sm:px-7 py-0 gap-0">
            
            {/* Left column - Identity */}
            <div className="flex-1 flex flex-col justify-center gap-0">
              <div 
                className="font-bold tracking-tight mb-2"
                style={{ 
                  fontSize: 'clamp(22px, 4.5vw, 30px)',
                  color: '#1A1A2E',
                  lineHeight: 1
                }}
              >
                Respons<span 
                  style={{
                    background: 'linear-gradient(135deg, #9B4FE8 0%, #3B8BF5 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}
                >IA</span>
              </div>
              <div 
                className="font-semibold mb-0.5"
                style={{ 
                  fontSize: 'clamp(11px, 2vw, 14px)',
                  color: '#1A1A2E',
                  letterSpacing: '0.01em'
                }}
              >
                Sabrina Adjarsa
              </div>
              <div 
                className="italic mb-3"
                style={{ 
                  fontSize: 'clamp(9px, 1.6vw, 11px)',
                  color: '#9490B8'
                }}
              >
                Fondatrice & CEO
              </div>
              <div 
                style={{ 
                  fontSize: 'clamp(8px, 1.4vw, 10px)',
                  color: '#9490B8',
                  lineHeight: 1.5,
                  maxWidth: '220px'
                }}
              >
                Plus de visibilité, plus de clients,<br/>grâce aux avis Google.
              </div>
            </div>
            
            {/* Vertical divider */}
            <div 
              className="flex-shrink-0 mx-4 sm:mx-6 hidden sm:block"
              style={{
                width: '1px',
                height: '60%',
                background: 'rgba(139,63,217,0.15)'
              }}
            />
            
            {/* Right column - Contacts */}
            <div className="flex flex-col justify-center gap-3 min-w-0">
              
              {/* Email */}
              <button 
                onClick={handleEmailClick}
                className="flex items-center gap-2 transition-all hover:translate-x-1 cursor-pointer text-left group"
              >
                <div 
                  className="flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '8px',
                    background: 'linear-gradient(135deg, rgba(155,79,232,0.12), rgba(59,139,245,0.12))',
                    border: '1px solid rgba(139,63,217,0.2)'
                  }}
                >
                  <Mail className="w-3.5 h-3.5 text-violet-600" />
                </div>
                <div className="flex flex-col">
                  <span 
                    className="text-[8px] sm:text-[9px] font-semibold tracking-wider uppercase"
                    style={{ color: '#9490B8', lineHeight: 1, marginBottom: '2px' }}
                  >
                    Email
                  </span>
                  <span 
                    className="text-[10px] sm:text-[12px] font-medium group-hover:text-violet-600 transition-colors"
                    style={{ color: '#1A1A2E', whiteSpace: 'nowrap' }}
                  >
                    sabrina.adjarsa@responsia.fr
                  </span>
                </div>
              </button>
              
              {/* Website */}
              <button 
                onClick={handleWebClick}
                className="flex items-center gap-2 transition-all hover:translate-x-1 cursor-pointer text-left group"
              >
                <div 
                  className="flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '8px',
                    background: 'linear-gradient(135deg, rgba(155,79,232,0.12), rgba(59,139,245,0.12))',
                    border: '1px solid rgba(139,63,217,0.2)'
                  }}
                >
                  <Globe className="w-3.5 h-3.5 text-blue-600" />
                </div>
                <div className="flex flex-col">
                  <span 
                    className="text-[8px] sm:text-[9px] font-semibold tracking-wider uppercase"
                    style={{ color: '#9490B8', lineHeight: 1, marginBottom: '2px' }}
                  >
                    Web
                  </span>
                  <span 
                    className="text-[10px] sm:text-[12px] font-medium group-hover:text-blue-600 transition-colors"
                    style={{ color: '#1A1A2E', whiteSpace: 'nowrap' }}
                  >
                    www.responsia.fr
                  </span>
                </div>
              </button>
              
              {/* Phone */}
              <button 
                onClick={handlePhoneClick}
                className="flex items-center gap-2 transition-all hover:translate-x-1 cursor-pointer text-left group"
              >
                <div 
                  className="flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform"
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '8px',
                    background: 'linear-gradient(135deg, rgba(155,79,232,0.12), rgba(59,139,245,0.12))',
                    border: '1px solid rgba(139,63,217,0.2)'
                  }}
                >
                  <Phone className="w-3.5 h-3.5 text-pink-600" />
                </div>
                <div className="flex flex-col">
                  <span 
                    className="text-[8px] sm:text-[9px] font-semibold tracking-wider uppercase"
                    style={{ color: '#9490B8', lineHeight: 1, marginBottom: '2px' }}
                  >
                    Tél
                  </span>
                  <span 
                    className="text-[10px] sm:text-[12px] font-medium group-hover:text-pink-600 transition-colors"
                    style={{ color: '#1A1A2E', whiteSpace: 'nowrap' }}
                  >
                    06 66 02 79 25
                  </span>
                </div>
              </button>
              
            </div>
          </div>
          
          {/* NFC badge */}
          <div 
            className="absolute bottom-3 right-3 flex items-center gap-1"
            style={{
              fontSize: '8px',
              fontWeight: 600,
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              color: '#3B8BF5',
              opacity: 0.6
            }}
          >
            <div 
              className="animate-pulse"
              style={{
                width: '5px',
                height: '5px',
                borderRadius: '50%',
                background: '#3B8BF5'
              }}
            />
            NFC
          </div>
        </div>
        
        {/* Hint below card */}
        <p 
          className="mt-4 text-center"
          style={{
            fontSize: '10px',
            fontWeight: 400,
            color: 'rgba(139,63,217,0.4)',
            letterSpacing: '0.06em'
          }}
        >
          Appuyez sur un lien pour contacter · NFC ready
        </p>
      </div>

      <style>{`
        @keyframes rise {
          from { opacity: 0; transform: translateY(20px) scale(0.97); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
};

export default BusinessCard;
